export default __webpack_public_path__ + "static/media/Screenshot (106).da5ddcc0.png";